<app-modal-wrapper
  title="Edit Permission"
  [isDirty]="permissionForm?.dirty ?? false"
  [formValid]="permissionForm?.valid ?? false"
  [showSaveButton]="true"
  (save)="save(permissionForm)"
  (closeRequest)="close()"
>
  <form #permissionForm="ngForm" class="flex flex-col gap-6 pt-2">
    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Permission Key
      </label>
      <input
        pInputText
        type="text"
        name="permissionKey"
        [ngModel]="model.permissionKey"
        class="w-full text-sm bg-gray-50 text-gray-500"
        readonly
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Route
      </label>
      <input
        pInputText
        type="text"
        name="routePath"
        [ngModel]="model.httpMethod + ' ' + model.routePath"
        class="w-full text-sm bg-gray-50 text-gray-500"
        readonly
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Display Name <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        type="text"
        name="displayName"
        [(ngModel)]="model.displayName"
        class="w-full text-sm"
        placeholder="Ex: Read Bank Account"
        maxlength="300"
        required
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Description
      </label>
      <textarea
        pTextarea
        name="description"
        [(ngModel)]="model.description"
        class="w-full text-sm"
        rows="3"
        maxlength="1000"
        placeholder="Optional description for this permission"
      ></textarea>
    </div>

    <div
      class="flex items-center gap-3 mt-2 p-3 bg-gray-50 rounded-lg transition-colors hover:bg-gray-100 cursor-pointer group"
      (click)="activeCheck.click()"
    >
      <div class="relative flex items-center justify-center w-5 h-5">
        <input
          #activeCheck
          type="checkbox"
          name="isActive"
          [(ngModel)]="model.isActive"
          class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
          (click)="$event.stopPropagation()"
        />
        <i
          class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"
        ></i>
      </div>
      <label class="font-bold text-gray-700 text-sm select-none flex-1 cursor-pointer">
        Feature Flag
      </label>
      <span
        class="text-xs font-bold px-2.5 py-1 rounded-full select-none"
        [ngClass]="
          model.isActive
            ? 'bg-green-100 text-green-700'
            : 'bg-gray-200 text-gray-500'
        "
      >
        {{ model.isActive ? 'Active' : 'Inactive' }}
      </span>
    </div>
  </form>
</app-modal-wrapper>
